import { DestroyRef, Directive, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SortModel } from '@iris/common/models/SortModel';
import { AgGridAngular } from 'ag-grid-angular';
import { provideGlobalGridOptions, SortChangedEvent } from 'ag-grid-community';
import { tap } from 'rxjs/operators';

@Directive({
  selector: 'ag-grid-angular',
})
export class AgGridQueryStateDirective implements OnInit {
  private readonly agGrid = inject(AgGridAngular);
  private readonly destroyRef = inject(DestroyRef);

  @Output() irisSortChange = new EventEmitter<SortModel | null>();
  @Output() irisMultiSortChange = new EventEmitter<SortModel[]>();

  private sortModel: SortModel | null = null;

  ngOnInit(): void {
    this.defaultGlobalOptions();

    this.agGrid.sortChanged.pipe(
      tap((_event: SortChangedEvent) => {
        const sortModel = this.agGrid.api.getColumnState().find(t => t.sort !== null);

        if (sortModel) {
          this.sortModel = { value: sortModel.colId, order: sortModel.sort };
          this.irisSortChange.emit(this.sortModel);
        } else {
          this.irisSortChange.emit(null);
        }

        const sortModels: SortModel[] = this.agGrid.api.getColumnState().filter(t => t.sort !== null).map((element) => {
          return { value: element.colId, order: element.sort };
        });
        this.irisMultiSortChange.emit(sortModels);
      }),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }

  private defaultGlobalOptions(): void {

    provideGlobalGridOptions({
      floatingFiltersHeight: 40,
      enableCellTextSelection: true,
    }, 'deep');
  }
}
